import { FirebaseModule, getFirebaseClient } from "@/utils/FirebaseUtils";
import { useEffect, useState } from "react";

export const useFirebase = (config: any, modules: FirebaseModule[]) => {
  const [firebase, setFirebase] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (firebase == null && !loading && modules.length > 0) {
      setLoading(true);
      getFirebaseClient(config, modules).then((firebase) => {
        setFirebase(firebase);
        setLoading(false);
      });
    }
  }, [config, modules]);

  return { firebase, loading };
};
